import { Array, String, Record } from "runtypes";

export const Invoice = Record({
  id: String,
  status: String,
  url: String,
  amount: String,
  date: String, // Date will be serialized as string from API
  lineItems: Array(String),
});

// The response is an array of invoices
export const UserInvoicesResponse = Array(Invoice);
